<template>
  <b-card v-loading="loading">
    <h4 ref="schedule">
      Posting Schedule
      <sup style="vertical-align: top;"><span class="info text-primary" v-b-tooltip.hover title="The schedule setup here represents how frequently and at what times your listing will be posted. We will post this listing at a random minute during the selected hour"><i class="icon-info"></i></span></sup>

      <div class="pull-right">
        <b-dropdown text="Add" variant="primary" class="m-0">
          <b-dropdown-item v-for="(_, idx) in 7" :key="idx" v-if="!schedule[idx]" @click="addDay(idx)">{{days[idx]}}</b-dropdown-item>
        </b-dropdown>
      </div>
    </h4>

    <b-table v-if="scheduleRows.length > 0" striped hover :items="scheduleRows" :fields="fields" class="mt-4 mb-0">
      <template slot="am" slot-scope="data">
        <div v-if="data.item.editable">
          <b-form-select v-model="data.item.am" :options="amOptions" />
        </div>
        <span v-else>{{format(data.item.am)}}</span>
      </template>
      <template slot="pm" slot-scope="data">
        <div v-if="data.item.editable">
          <b-form-select v-model="data.item.pm" :options="pmOptions" />
        </div>
        <span v-else>{{format(data.item.pm)}}</span>
      </template>
      <template slot="actions" slot-scope="data">
        <div class="actions">
          <button v-if="data.item.editable" class="action text-success" @click="setSchedule(data.item)"><i class="icon-check"></i></button>
          <button v-else class="action text-primary" @click="setSchedule(data.item)"><i class="icon-pencil"></i></button>
          <button v-if="!data.item.editable" class="action text-danger" @click="deleteSchedule(data.item)"><i class="icon-close"></i></button>
        </div>
      </template>
    </b-table>
    <b-alert v-else :show="true" variant="warning" class="mt-4 mb-0 py-2 px-3 d-flex align-items-center">
      <i class="icon-info mr-2"></i> There are no posts scheduled for this listing
    </b-alert>
  </b-card>
</template>

<script>
import EventBus from "../../../shared/event-bus";

const fields = {
  'day': {
    label: 'Day',
  },
  'am': {
    label: 'Morning',
    class: 'text-center',
    thStyle: { width: '130px' }
  },
  'pm': {
    label: 'Afternoon',
    class: 'text-center',
    thStyle: { width: '130px' }
  },
  'actions': {
    label: '',
    class: 'text-center',
    thStyle: { width: '90px' }
  }
}

const format = (hour) => {
  if( hour === 12 ){
    return 'Noon'
  }
  if( hour === 0 ){
    return 'Midnight'
  }

  return hour > 12 ? `${hour-12} PM` : `${hour} AM`
}

const amOptions = Array(12).fill().map((_, value) => {
  return {
    value: value,
    text: format(value)
  }
})

const pmOptions = Array(12).fill().map((_, value) => {
  return {
    value: value+12,
    text: format(value+12)
  }
})

const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

// Defaults 9 and 5
const defaultAM = 9
const defaultPM = 17

export default {
  name: 'Schedule',

  components: {
  },

  props: {
    schedule: {
      type     : Object,
      required : true
    },
    loading: {
      type    : Boolean,
      default : false,
    }
  },

  data(){
    return {
      fields,

      days,
      amOptions,
      pmOptions,

      // State
      scheduleRows: [],
      error : '',
    }
  },

  mounted(){
    if( Object.keys(this.schedule).length === 0 && !this.$route.params.id ){
      this.schedule[1] = [defaultAM, defaultPM]
    }

    this.recomputeSchedule()
  },

  beforeDestroy(){
    if( this._message ){
      EventBus.$emit('messages.hide', this._message)
    }
  },

  watch: {
    schedule(){
      this.recomputeSchedule()
    }
  },

  methods: {
    format,

    recomputeSchedule(editRow = -1){
      this.scheduleRows = Object.keys(this.schedule).map((key) => {
        key = parseInt(key)
        let hours = this.schedule[key]
        return {
          key,
          day      : days[key],
          am       : hours[0],
          pm       : hours[1],
          editable : editRow === key,
        }
      })

      if( this.scheduleRows.length === 0 ){
        if( this._message ){
          EventBus.$emit('messages.hide', this._message)
        }
        EventBus.$emit('messages.show', ['This listing has no schedule setup so it <strong>cannot be posted</strong>. Please add one or more scheduled times at the bottom of the page.', 'warning', this.scrollTo.bind(this)], ({ id }) => {
          this._message = id
        })
      }
      else {
        if( this._message ){
          EventBus.$emit('messages.hide', this._message)
        }
      }
    },

    setSchedule(item){
      const { key, am, pm } = item
      if( !item.editable ){
        item.editable = true
        return
      }

      this.schedule[key] = [am, pm]
      item.editable = !item.editable
      this.recomputeSchedule()
      this.$emit('schedule-changed', this.schedule)
    },

    deleteSchedule(item){
      const { key } = item
      delete this.schedule[key]
      this.recomputeSchedule()
      this.$emit('schedule-changed', this.schedule)
    },

    addDay(key){
      this.schedule[key] = [defaultAM, defaultPM]
      this.recomputeSchedule()
      this.$emit('schedule-changed', this.schedule)
    },

    scrollTo(){
      var container = this.$refs.schedule;
      container.scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  align-items: center;
  justify-content: center;

  .action {
    outline: none;
    border: 0;
    background: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    border-radius: 50%;
  }
}
</style>
